import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { PoultryItem } from "@/components/poultry/types";
import { useQueryClient } from "@tanstack/react-query";

export const useRestockManagement = () => {
  const [isRestockDialogOpen, setIsRestockDialogOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<PoultryItem | null>(null);
  const [restockQuantity, setRestockQuantity] = useState("");
  const queryClient = useQueryClient();

  const handleRestockClick = (item: PoultryItem) => {
    setSelectedItem(item);
    setIsRestockDialogOpen(true);
  };

  const handleRestockConfirm = async () => {
    if (!selectedItem || !restockQuantity) return;

    try {
      const newQuantity = selectedItem.quantity + parseInt(restockQuantity);
      const { error } = await supabase
        .from('stock_items')
        .update({ quantity: newQuantity })
        .eq('id', selectedItem.id);

      if (error) throw error;

      queryClient.invalidateQueries({ queryKey: ['poultryInventory'] });
      setIsRestockDialogOpen(false);
      setRestockQuantity("");
      setSelectedItem(null);
      toast.success("Stock mis à jour avec succès");
    } catch (error) {
      console.error("Erreur lors du réapprovisionnement:", error);
      toast.error("Erreur lors de la mise à jour du stock");
    }
  };

  return {
    isRestockDialogOpen,
    setIsRestockDialogOpen,
    selectedItem,
    restockQuantity,
    setRestockQuantity,
    handleRestockClick,
    handleRestockConfirm,
  };
};